import type { HelpFile } from '../../types/help'
import { VersionHistoryCardTestIds } from '../../../testids/VersionHistoryCardTestIds'

export const versionHistoryCardHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [VersionHistoryCardTestIds.versionHistoryCard]:
      'Versionsverlauf dieser Einschränkungsregel — jede gespeicherte Revision mit Autor und Zeitstempel.',
    [VersionHistoryCardTestIds.cardTitleVersionHistory]: null,
    [VersionHistoryCardTestIds.versionLoading]: null,
    [VersionHistoryCardTestIds.versionEmpty]:
      'Für diese Regel existieren noch keine früheren Versionen.',
    [VersionHistoryCardTestIds.versionError]:
      'Versionsverlauf konnte nicht geladen werden. Versuchen Sie es später erneut oder prüfen Sie das Fehlerprotokoll.',
  },
}
